import type { StakeholderTemplate } from '@bandos/shared'

export const MAX_TEAM_SIZE = 6

export interface CharacterSelectionModalProps {
  isVisible: boolean
  onClose: () => void
  initialSelectedTemplateId?: string
}

export type RightPanelView = 'empty' | 'profile' | 'create' | 'edit'

export interface FormData {
  name: string
  role: string
  role_summary: string
  goals: string[]
  concerns: string[]
  success_metrics: string[]
  extra_rules: string[]
}

export const emptyFormData: FormData = {
  name: '',
  role: '',
  role_summary: '',
  goals: [''],
  concerns: [''],
  success_metrics: [''],
  extra_rules: [''],
}

export type ArrayField = 'goals' | 'concerns' | 'success_metrics' | 'extra_rules'

// Shared portrait props used by PortraitDisplay
export interface PortraitDisplayProps {
  template: StakeholderTemplate
  size: 'card' | 'slot' | 'large'
  brokenPortraits: Set<string>
  markPortraitBroken: (id: string) => void
  isGenerating: boolean
}
